import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage } from 'react-use';
import { useHistory, useParams } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';
import natsort from 'hooks/natsort.js';
import AuditeeEvalAnswerInput from '../Widget/Evaluation/Auditee/Input.js';
import AuditeeEvalAnswerFormula from '../Widget/Evaluation/Auditee/Formula.js';
import AuditeeEvalAnswerTable from '../Widget/Evaluation/Auditee/Table.js';
import {Loading} from 'components/Loading/loading';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import { textDecorationUpdate } from '@syncfusion/ej2-react-spreadsheet';
import FormRepository from 'repository/Form.js';

export default function Auditee() {

  const history = useHistory();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const {formId, employeeId} = useParams();

  const [schedule, setSchedule] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);
  const [readonly, setReadonly] = useState(false);
  const [formulas, setFormulas] = useState([]);
  const repository = new FormRepository(auth.token);

  const handleClick = async (e) => {
    e.preventDefault();
    return history.push(`/auditee/${auth.employee.EMP_ID}/audits`);
  }

  const handleClickA = async (e) => {
    e.preventDefault();
    return history.push(`/auditee/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/evaluations`);
  }

  const fetchForm = async () => {

    try {

      const response = await repository.fetch(formId);

      //check status to readonly mode
      if (response.data.SUBMIT_AT !== null) {
        setReadonly(true);
      }

      setSchedule(response.data.schedule);
      setCriteria(response.data.criteria);
      setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setScores(response.data.schedule.instrument.score.scoreIndices);


    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(() => {
    fetchForm();
    const body = document.querySelector('#root');

    body.scrollIntoView({
        behavior: 'smooth'
    }, 200)
  }, []);

  return (
    <Container fluid>
      {swal}
      <Breadcrumb>
        <Breadcrumb.Item onClick={handleClick}>
          Audit
        </Breadcrumb.Item>
        {/* <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          {schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item> */}
        <Breadcrumb.Item onClick={handleClickA}>
          {schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Desk Evaluation
        </Breadcrumb.Item>
      </Breadcrumb>
      {!criteria && <Loading />}
      {criteria && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {answers && schedule && answers.map((answer, key) => {
        switch (answer.question.QUESTION_TYPE_ID) {
          case 1:
            return (
            <AuditeeEvalAnswerInput key={key} answer={answer} isReadonly={readonly} >
            </AuditeeEvalAnswerInput>
                // <AuditorEvaluationAnswerInput
                //     key={key}
                //     scores={scores}
                //     answer={answer}
                //     isReadonly={readonly}
                //   >
                // </AuditorEvaluationAnswerInput>
            );
          case 2:
            return <AuditeeEvalAnswerFormula key={key} answer={answer} formulas={formulas} setFormulas={setFormulas} isReadonly={readonly} />;
          case 3:
            return (
            <AuditeeEvalAnswerTable
              key={key}
              scores={scores}
              schedule={schedule}
              answer={answer}
              isReadonly={readonly} >
            </AuditeeEvalAnswerTable>
            );
        }
      })}

    </Container>
  )
}